import { render, staticRenderFns } from "./newsContent.vue?vue&type=template&id=1089191f"
import script from "./newsContent.vue?vue&type=script&lang=js"
export * from "./newsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports